module.exports = __webpack_public_path__ + "static/media/taptap.362f179f.png";